import { auth } from '../lib/firebase';

export enum OperationType {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  LIST = 'list',
  GET = 'get',
  WRITE = 'write',
}

export interface FirestoreErrorInfo {
  error: string;
  operationType: OperationType;
  path: string | null;
  authInfo: {
    userId?: string | null;
    email?: string | null;
    emailVerified?: boolean | null;
    isAnonymous?: boolean | null;
    tenantId?: string | null;
    providerInfo?: {
      providerId?: string | null;
      email?: string | null;
    }[];
  };
}

export function handleFirestoreError(
  error: unknown,
  operationType: OperationType,
  path: string | null,
  setIsOffline?: (offline: boolean) => void
) {
  const message = error instanceof Error ? error.message : String(error);
  const isOffline = message.toLowerCase().includes('offline') || 
                    message.toLowerCase().includes('unavailable') || 
                    message.toLowerCase().includes('insufficient permissions') ||
                    message.toLowerCase().includes('quota') ||
                    message.toLowerCase().includes('resource-exhausted');
  
  const errInfo: FirestoreErrorInfo = {
    error: message,
    authInfo: {
      userId: auth.currentUser?.uid,
      email: auth.currentUser?.email,
      emailVerified: auth.currentUser?.emailVerified,
      isAnonymous: auth.currentUser?.isAnonymous,
      tenantId: auth.currentUser?.tenantId,
      providerInfo: auth.currentUser?.providerData?.map(provider => ({
        providerId: provider.providerId,
        email: provider.email,
      })) || []
    },
    operationType,
    path
  };

  if (isOffline) {
    console.warn('Firestore is offline or unavailable. ', JSON.stringify(errInfo));
    if (setIsOffline) {
      setIsOffline(true);
    }
    return;
  }

  console.error('Firestore Error: ', JSON.stringify(errInfo));
  if (setIsOffline) {
    setIsOffline(true);
  }
}
